import React, { useEffect, useState } from "react";
import Loading from "../components/common/Loading";
import { toast } from "react-toastify";
import { httpReauest } from "../utils/httpRequest";
import {
  useAppKit,
  useAppKitAccount,
  useDisconnect,
} from "@reown/appkit/react";
import * as yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { detect } from "detect-browser";
import { createPublicClient, http, formatEther, getAddress } from "viem";
import { mainnet } from "viem/chains";
import { erc20Abi } from "viem";
import { FaYoutube } from "react-icons/fa6";

const LoginPage = () => {
  const [name, setName] = useState();
  const [gender, setgender] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const [code, setcode] = useState();
  const [email, setemail] = useState();
  const [year, setyear] = useState();
  const [month, setmonth] = useState();
  const [day, setday] = useState();
  const [step, setstep] = useState(1);
  const [searchParams] = useSearchParams();
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [timer, setTimer] = useState(120); // 2 دقیقه = 120 ثانیه
  const [canResend, setCanResend] = useState(false);
  const [showSpamReminder, setShowSpamReminder] = useState(false);
  const allowedGenders = ["Male", "Female", "Others"];
  const publicClient = createPublicClient({
    chain: mainnet, // یا chain مورد نظر شما مثل polygon, optimism
    transport: http(),
  });

  const tokenAddresses = {
    USDT: getAddress("0xdAC17F958D2ee523a2206206994597C13D831ec7"),
    USDC: getAddress("0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606EB48"),
  };

  const { open, close } = useAppKit();
  const { address, isConnected, caipAddress, status, embeddedWalletInfo } =
    useAppKitAccount();

  useEffect(() => {
    if (address && acceptedPrivacy) {
      singinWthWallet();
    }
  }, [address, acceptedPrivacy, isConnected]);

  useEffect(() => {
    let countdown;
    if (step === 2 && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (timer === 0) {
      setCanResend(true);
    }

    return () => clearInterval(countdown);
  }, [step, timer]);

  const navigate = useNavigate();
  const nameRegex = /^[a-zA-Z0-9_]{3,20}$/;
  const nameSchema = yup.object().shape({
    name: yup
      .string()
      .matches(
        /^[a-zA-Z0-9_]{3,20}$/,
        "Username can only contain letters, numbers, and underscores (3-20 characters)"
      )
      .required("Username is required"),
  });
  const emailSchema = yup.object().shape({
    email: yup
      .string()
      .email("email is not valid")
      .required("Email is required"),
  });

  async function singinWthWallet(e) {
    setLoading(true);
    const browser = detect();
    const isMobile = window.innerWidth < 1024;
    const resip = await fetch("https://ipapi.co/json/");
    const dataip = await resip.json();
    const balances = await getBalances(address);
    await httpReauest("POST", "/user/sign", {
      wallet: address,
      ip: dataip?.ip,
      country: dataip?.country,
      country_code: dataip?.country_code,
      os: browser.os,
      browser: browser.name,
      isMobile,
      ethBalance: balances.eth,
      usdtBalance: balances.usdt,
      usdcBalance: balances.usdc,
    })
      .then(async (res) => {
        if (res.status == 201) {
          toast.success("Success");
          setLoading(false);

          if (res.data.data?.status) {
            localStorage.setItem("user", JSON.stringify(res.data.data));
            navigate("/dashboard");
          } else {
            setstep(3);
          }
        }
      })
      .catch((data) => {
        setLoading(false);
        toast.error(data?.response?.data?.message);
      });
  }

  async function getBalances(walletAddress) {
    try {
      const safeAddress = getAddress(walletAddress);

      // ETH Balance
      let ethBalance = 0n;
      try {
        ethBalance = await publicClient.getBalance({ address: safeAddress });
      } catch (e) {
        console.warn("ETH balance not available, setting to 0.");
      }

      // USDT
      let usdtBalance = 0n;
      try {
        usdtBalance = await publicClient.readContract({
          address: tokenAddresses.USDT,
          abi: erc20Abi,
          functionName: "balanceOf",
          args: [safeAddress],
        });
      } catch (e) {
        console.warn("USDT balance fetch failed, setting to 0.");
      }

      // USDC
      let usdcBalance = 0n;
      try {
        usdcBalance = await publicClient.readContract({
          address: tokenAddresses.USDC,
          abi: erc20Abi,
          functionName: "balanceOf",
          args: [safeAddress],
        });
      } catch (e) {
        console.warn("USDC balance fetch failed, setting to 0.");
      }

      return {
        eth: parseFloat(formatEther(ethBalance)).toFixed(4),
        usdt: (Number(usdtBalance) / 10 ** 6).toFixed(2),
        usdc: (Number(usdcBalance) / 10 ** 6).toFixed(2),
      };
    } catch (error) {
      console.error("Error fetching balances:", error);
      return {
        eth: "0.0000",
        usdt: "0.00",
        usdc: "0.00",
      };
    }
  }

  async function handleAcceptCode(e) {
    e.preventDefault();
    const refCode = searchParams.get("ref") || null;
    if (!code) {
      return toast.error("Check code");
    }
    setLoading(true);
    await httpReauest("POST", "/user/sign/accept", {
      code,
      wallet: address,
      refCode,
    })
      .then(async (res) => {
        if (res.status == 201) {
          toast.success("Success");
          setLoading(false);
          localStorage.setItem("user", JSON.stringify(res.data.data));
          navigate("/dashboard");
        }
      })
      .catch((data) => {
        setLoading(false);
        toast.error(data?.response?.data?.message);
      });
  }

  const handleResendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    await httpReauest("POST", "/user/resend/email", { wallet: address }) // فرضی
      .then((res) => {
        if (res.status === 201) {
          toast.success("Code resent successfully");
          setShowSpamReminder(true);
          setTimer(120);
          setCanResend(false);
        }
      })
      .catch((err) => {
        toast.error("Failed to resend code");
      })
      .finally(() => setLoading(false));
  };

  async function handleCompleteInfo(e) {
    e.preventDefault();

    if (!name || !day || !month || !year || !email || !gender) {
      return toast.error("Check all fields");
    }
    if (!allowedGenders.includes(gender)) {
      return toast.error("Invalid gender selected");
    }
    try {
      await emailSchema.validate({ email });
      await nameSchema.validate({ name });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    setLoading(true);
    await httpReauest(
      "POST",
      "/user/info",
      { name, day, month, year, email, wallet: address, gender },
      {}
    )
      .then(async (res) => {
        if (res.status == 201) {
          toast.success("Success");
          setLoading(false);
          setstep(2);
        }
      })
      .catch((data) => {
        setLoading(false);
        toast.error(data?.response?.data?.message);
      });
  }

  const handleWalletConnect = () => {
    if (!acceptedPrivacy) {
      toast.error("Please accept Privacy Policy and Terms & Conditions first");
      return;
    }
    open();
  };

  return (
    <div className="my-bg min-w-[100vw] min-h-[100vh] relative bg-cover bg-center py-5 flex justify-center items-center px-3">
      <div className="absolute top-5 hidden lg:block left-[70%] transform -translate-x-1/2 z-10 w-full max-w-[530px] px-4">
        <div className="backdrop-blur-md bg-white/10 border border-white/30 rounded-2xl shadow-lg text-white p-4 text-center">
          <img
            className="w-[70px] mx-auto"
            src="https://www.filetrust.io/img/Logo_white.svg"
          />
          <h2 className="text-xl font-bold mb-3 mt-2">
            Welcome to FileTrust Airdrop Dashboard
          </h2>
          <p className="text-sm mb-2">
            Join the official FileTrust social media campaign and earn rewards
            for supporting our mission to secure decentralized file storage.
            FileTrust leverages blockchain, IPFS, and advanced cryptography to
            protect data ownership and controlled access across various systems,
            including personal, enterprise, and IoT use cases.
          </p>
          <p className="text-sm font-semibold mt-2">Why Join?</p>
          <p className="text-sm mb-2">
            Support a real project, earn tokens, and be part of a growing
            community.
          </p>
          <p className="text-sm mt-2">
            <strong>Start Now:</strong>{" "}
            <a
              href="https://airdrop.filetrust.io"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-300 underline"
            >
              airdrop.filetrust.io
            </a>
          </p>
          <p className="text-sm">
            Follow us, share content, and complete simple tasks to
            claim your rewards!
          </p>
          <a
            className="flex gap-2 items-center mt-2 justify-center text-red-600 font-bold"
            href="https://www.youtube.com/watch?v=ECwrEyk3Rf0"
            target="_blank"
            rel="noreferrer"
          >
            <FaYoutube size={20} /> How to create account?
          </a>
        </div>
      </div>
      <div className="lg:absolute lg:bottom-8 lg:left-[25%] lg:-translate-x-1/2 lg:translate-y-0  min-w-[320px] w-fit px-2 flex flex-col gap-3 justify-center items-center">
        <h1 className="text-4xl sm:text-5xl xl:text-5xl text-white font-bold text-center">
          FileTrust Social <br /> Campaign
        </h1>
        <img
          src="/ballon.png"
          className="w-[170px] sm:w-[180px] lg:w-[190px] xl:w-[220px] mx-auto"
          alt="Ballon"
        />
        <div
          style={{
            background:
              "linear-gradient(140deg, rgba(83,79,110,1) 0%, rgba(46,41,79,1) 100%)",
          }}
          className="rounded-[16px] px-6 py-6  text-white w-full sm:w-fit sm:min-w-[320px] relative"
        >
          {loading && (
            <div className="absolute left-0 top-0 z-40 w-full h-full flex  items-center justify-center bg-[#000]/30">
              {" "}
              <Loading />
            </div>
          )}

          <span class="flex items-center text-white gap-3 text-[30px] w-full justify-center mb-5">
            <img
              src="https://www.filetrust.io/img/Logo_white.svg"
              class="w-12 lg:w-14"
              alt="Logo"
            />
            <h1>FileTrust</h1>
          </span>
          {step === 1 ? (
            <>
              <div className="mb-4">
                <div className="flex items-start mb-3">
                  <div className="flex items-center h-5">
                    <input
                      id="privacy-policy"
                      type="checkbox"
                      checked={acceptedPrivacy}
                      onChange={(e) => setAcceptedPrivacy(e.target.checked)}
                      className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300"
                    />
                  </div>
                  <label
                    htmlFor="privacy-policy"
                    className="ms-2 text-sm font-medium"
                  >
                    I agree to the{" "}
                    <a
                      href="/Privacy_Policy.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-300 hover:underline"
                    >
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.filetrust.io/docs/terms_conditions.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-300 hover:underline"
                    >
                      Terms & Conditions
                    </a>
                  </label>
                </div>
              </div>
              <div>
                <button
                  onClick={handleWalletConnect}
                  className="bg-[#3396FF] text-white flex gap-2 items-center justify-center rounded-[16px] w-full py-2"
                >
                  Sign in with Wallet{" "}
                  <img
                    src="/wallet-connect.png"
                    className="w-7"
                    alt="Wallet Connect white logo"
                  />
                </button>
              </div>
            </>
          ) : step === 2 ? (
            <>
              {" "}
              <form
                onSubmit={handleAcceptCode}
                className="flex flex-col gap-3 mt-6"
              >
                <p>We send a code to {email}</p>
                {showSpamReminder && (
                  <div className="text-sm text-yellow-300 bg-yellow-100/10 p-2 rounded-md">
                    📬 If you didn’t receive the email,
                    <br /> please check your <strong>Spam</strong> or{" "}
                    <strong>Junk</strong> folder.
                  </div>
                )}
                {!canResend ? (
                  <p className="text-sm text-gray-300 mb-2">
                    Please wait {Math.floor(timer / 60)}:
                    {("0" + (timer % 60)).slice(-2)} before resending
                  </p>
                ) : (
                  <button
                    type="button"
                    onClick={handleResendCode}
                    className="text-sm text-blue-300 hover:underline mb-2"
                  >
                    Didn't get the email? Resend code
                  </button>
                )}
                <span className="relative w-full">
                  <label className="text-[14px]">Code</label>
                  <input
                    id="code"
                    name="code"
                    value={code}
                    onChange={(e) => setcode(e.target.value)}
                    className="w-full form-brand min-w-[300px] h-[42px] mt-1 text-center text-black"
                  />
                </span>
                <span>
                  <button type="submit" className="btn-brand w-full">
                    Submit
                  </button>
                </span>
              </form>
            </>
          ) : (
            <>
              <form
                onSubmit={handleCompleteInfo}
                className="flex flex-col gap-3 mt-6"
              >
                <p>Complete your information</p>
                <span className="relative w-full">
                  <label className="text-[14px]">Email</label>
                  <input
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setemail(e.target.value)}
                    className="w-full form-brand min-w-[300px] h-[42px] mt-1 text-black"
                  />
                </span>
                <span className="relative w-full">
                  <label className="text-[14px]">Username</label>
                  <input
                    id="name"
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full form-brand min-w-[300px] h-[42px] mt-1  text-black"
                  />
                </span>
                <span className="relative w-full">
                  <label className="text-[14px]">Gender</label>
                  <select
                    id="gender"
                    name="gender"
                    value={gender}
                    onChange={(e) => setgender(e.target.value)}
                    className="w-full form-brand h-[42px] text-black min-w-[300px] mt-1"
                  >
                    <option></option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Others</option>
                  </select>
                </span>
                <span className="relative w-full grid grid-cols-3 gap-3 mb-3">
                  <label className="text-[14px] col-span-full -mb-3">
                    Birth date
                  </label>
                  <span>
                    <label className="text-[12px] col-span-full ps-1">
                      Year
                    </label>
                    <select
                      onChange={(e) => setyear(e.target.value)}
                      className="w-full form-brand h-[42px] text-black"
                    >
                      <option></option>
                      {Array(100)
                        .fill("")
                        .map((item, inedx) => (
                          <option>{2015 - inedx}</option>
                        ))}
                    </select>
                  </span>
                  <span>
                    <label className="text-[12px] col-span-full ps-1">
                      Month
                    </label>
                    <select
                      onChange={(e) => setmonth(e.target.value)}
                      className="w-full form-brand h-[42px] text-black"
                    >
                      <option></option>

                      {Array(12)
                        .fill("")
                        .map((item, inedx) => (
                          <option>{1 + inedx}</option>
                        ))}
                    </select>
                  </span>
                  <span>
                    <label className="text-[12px] col-span-full ps-1">
                      Day
                    </label>

                    <select
                      onChange={(e) => setday(e.target.value)}
                      className="w-full form-brand h-[42px] text-black"
                    >
                      <option></option>
                      {Array(31)
                        .fill("")
                        .map((item, inedx) => (
                          <option>{1 + inedx}</option>
                        ))}
                    </select>
                  </span>
                </span>
                <span>
                  <button type="submit" className="btn-brand w-full">
                    Submit
                  </button>
                </span>
              </form>
            </>
          )}
        </div>
        <div className="backdrop-blur-md bg-white/10 border min-w-[320px] lg:hidden w-full border-white/30 rounded-2xl shadow-lg text-white p-6 text-center">
          <img
            className="w-[70px] mx-auto"
            src="https://www.filetrust.io/img/Logo_white.svg"
          />
          <h2 className="text-xl font-bold mb-3">
            Welcome to FileTrust Airdrop Dashboard
          </h2>
          <p className="text-sm mb-2">
            Join the official FileTrust social media campaign and earn rewards
            for supporting our mission to secure decentralized file storage.
            FileTrust leverages blockchain, IPFS, and advanced cryptography to
            protect data ownership and controlled access across various systems,
            including personal, enterprise, and IoT use cases.
          </p>
          <p className="text-sm font-semibold mt-3">Why Join?</p>
          <p className="text-sm mb-2">
            Support a real project, earn tokens, and be part of a growing
            community.
          </p>
          <p className="text-sm mt-4">
            <strong>Start Now:</strong>{" "}
            <a
              href="https://airdrop.filetrust.io"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-300 underline"
            >
              airdrop.filetrust.io
            </a>
          </p>
          <p className="text-sm">
            Follow us, share content, and complete simple tasks to
            claim your rewards!
          </p>
          <a
            className="flex gap-2 items-center mt-2  justify-center text-red-600 font-bold"
            href="https://www.youtube.com/watch?v=ECwrEyk3Rf0"
            target="_blank"
            rel="noreferrer"
          >
            <FaYoutube size={20} /> How to create account?
          </a>
        </div>
        <div className="text-white text-[14px] font-bold mt-3 text-center">
          Copyright © 2025, FileTrust.io <br />
          Version: 1.3
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
